import React from "react";

import ThingsSection from "../components/Things";
import ConditionSection from "../components/Condition";
import { Link } from "react-router-dom";

const FactsPage = () => {

const ThingsData = {
    image: "./images/Things1.jpg",
    heading: "Things You Should Know About Mold",

    // Changed intro to array of 3 items
    intro: [
        "Potential health effects and symptoms associated with mold exposure include allergic reactions, asthma, and other respiratory complaints.",
        "If mold problem in your home, you must consult a mold specialist to test and find the mold sources, it may be a health hazard.",
        "Find and Fix the source of the water problem or leak to prevent mold growth."
    ],

   
  

    checklist: [
        "Reduce indoor humidity (to 30-60% ) to decrease mold growth by venting bathrooms, dryers, and other moisture-generating sources to the outside; using air conditioners and de-humidifiers; increasing ventilation; and using exhaust fans whenever cooking, dishwashing, and cleaning.",
        "Prevent condensation: Reduce the potential for condensation on cold surfaces (i.e., windows, piping, exterior walls, roof, or floors) by adding insulation.",
        "In areas where there is a perpetual moisture problem, do not install carpeting (i.e., by drinking fountains, by classroom sinks, or on concrete floors with leaks or frequent condensation).",
        "Molds can be found almost anywhere; they can grow on virtually any substance, providing moisture is present. Some molds can grow on wood, paper, carpet, and food.",
        
    ],

    summary: "How do molds affect people?",

    standards: "Some people are sensitive to mold. For these people, mold exposure can cause symptoms such as nasal stuffiness, eye irritation, wheezing, or skin irritation. Some people, such as those with serious allergies to molds, may have more severe reactions. Severe reactions may occur among workers exposed to large amounts of mold in occupational settings, such as farmers working around moldy hay. Severe reactions may include fever and shortness of breath. Some people with chronic lung illnesses, such as obstructive lung disease, may develop mold infections in their lungs.",

};

const conditionData = {
    image: "./images/think2.jpg", 
    heading: "What should you do if mold is present in your home or apartment?",
    intro: "Potential health effects and symptoms associated with mold exposure include allergic reactions, asthma, and other respiratory complaints. If mold problem in your home, you must consult a mold specialist to test and find the mold sources, it may be a health hazard. Visible mold can be tested by an environmental consultant and/or analyzed by a laboratory specializing in microbiology.",
    
    types: [
        {
            title: "",
            text: ""
        },
        {
            title: "",
            text: ""
        },
        {
            title: "",
            text: ""
        }
    ],
    checklist: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
    ],
    summary: "Indoor Air Quality tests can be performed to check the air spores or air contamination, by a specialist. Sometimes, even if you had your home tested, it is difficult to say at what levels molds would cause health effects. Therefore, it is more important to get rid of the mold and mold-affected material rather than find out more about it. The most effective way to treat mold is to correct water damage and get mold remediation.",
    standards: "Should you see a physician?",
    contactNote: "If you believe that you or your children have symptoms that you suspect are caused by exposure to mold, you should see a physician. Keep in mind that many symptoms associated with mold exposure may also be caused by many other illnesses. You should tell your physician about the symptoms and about when, how, and for how long you think you or your children were exposed."
};

  return (
    <>
      <div class="fact-page-004 common-001">
        <section className="section-banner">
          <div className="container">
            <div className="inner-content">
              <p>Fast, Reliable Home Inspections for Agents & Homeowners</p>
              <h1>
                Mold<span> Inspections</span>
              </h1>
              <p>
                Discover peace of mind with our expert home inspection services,
                designed to meet the needs of both real estate agents and
                property owners. Our team ensures thorough evaluations and
                prompt reporting, helping you make informed decisions.
              </p>
              <div className="dft-btn">
                <Link to="/industerial-building" className="btn">
                  For Inspection Services
                </Link>
              </div>
            </div>
          </div>
        </section>

        <ThingsSection ThingsData={ThingsData} />

        <ConditionSection conditionData={conditionData} />

      </div>
    </>
  );
};

export default FactsPage;
